/**
 * Static racket dataset for the homepage quiz.
 * Generated by scripts/refresh-quiz-data.js
 * Last regenerated: 2026-11-02T22:24:33.090Z
 *
 * To regenerate: `npm run refresh-quiz-data`
 *
 * Total rackets: 72
 */
window.LATIENDA_RACKETS = [
  {
    "handle": "bullpadel-hack-03-2024",
    "title": "Bullpadel Hack 03 2024",
    "vendor": "Bullpadel",
    "url": "/products/bullpadel-hack-03-2024",
    "image": "https://cdn.shopify.com/s/files/1/0734/4609/7068/files/a1rbv9s2a015anec2ba01c35ncn0.webp?v=1777600079",
    "price": 12499,
    "compare_at_price": 15000,
    "available": true,
    "level": "Advanced",
    "suitable_levels": [
      "Advanced"
    ],
    "shape": "Diamond",
    "style": "Power",
    "inherited": false
  },
  {
    "handle": "siux-st3-electra-pro-franco-stupaczuk",
    "title": "Siux ST3 Electra Pro - Franco Stupaczuk",
    "vendor": "Siux",
    "url": "/products/siux-st3-electra-pro-franco-stupaczuk",
    "image": "https://cdn.shopify.com/s/files/1/0734/4609/7068/files/j47ptwzu55d8jal3nbm7csbzl7qb.webp?v=1777600066",
    "price": 12499,
    "compare_at_price": 14250,
    "available": true,
    "level": "Advanced",
    "suitable_levels": [
      "Advanced"
    ],
    "shape": "Hybrid",
    "style": "Control",
    "inherited": false
  },
  {
    "handle": "wilson-defy-v1-2025-javi-garrido",
    "title": "Wilson Defy V1 2025 - Javi Garrido",
    "vendor": "Wilson",
    "url": "/products/wilson-defy-v1-2025-javi-garrido",
    "image": "https://cdn.shopify.com/s/files/1/0734/4609/7068/files/kmkvq6d71igok84seoy0kfhfft2n.webp?v=1779182833",
    "price": 12999,
    "compare_at_price": 0,
    "available": true,
    "level": "Advanced",
    "suitable_levels": [
      "Advanced"
    ],
    "shape": "Diamond",
    "style": "Power",
    "inherited": false
  },
  {
    "handle": "wilson-defy-ls-v1-2025-javi-garrido",
    "title": "Wilson Defy LS V1 2025 - Javi Garrido",
    "vendor": "Wilson",
    "url": "/products/wilson-defy-ls-v1-2025-javi-garrido",
    "image": "https://cdn.shopify.com/s/files/1/0734/4609/7068/files/jh00v230ye30k5my1kvigtz2z807.webp?v=1778109030",
    "price": 10999,
    "compare_at_price": 0,
    "available": false,
    "level": "Advanced",
    "suitable_levels": [
      "Advanced"
    ],
    "shape": "Diamond",
    "style": "Power",
    "inherited": false
  },
  {
    "handle": "drop-shot-tiger-40-jr-padel-racket",
    "title": "Drop Shot Tiger 4.0 Jr Padel Racket",
    "vendor": "Drop Shot",
    "url": "/products/drop-shot-tiger-40-jr-padel-racket",
    "image": "https://cdn.shopify.com/s/files/1/0734/4609/7068/files/iwqn83h9p9m51z6y43dn1og8is8i.webp?v=1777598470",
    "price": 4500,
    "compare_at_price": 0,
    "available": true,
    "level": "Beginner",
    "suitable_levels": [
      "Beginner",
      "Junior"
    ],
    "shape": "Round",
    "style": "Balanced",
    "inherited": false
  },
  {
    "handle": "drop-shot-axion-attack-jon-sanz",
    "title": "Drop Shot Axion Attack - Jon Sanz",
    "vendor": "Drop Shot",
    "url": "/products/drop-shot-axion-attack-jon-sanz",
    "image": "https://cdn.shopify.com/s/files/1/0734/4609/7068/files/fsh0xq6berkccrxupf003ni2xgku.webp?v=1777598458",
    "price": 12999,
    "compare_at_price": 16000,
    "available": true,
    "level": "Advanced",
    "suitable_levels": [
      "Advanced"
    ],
    "shape": "Teardrop",
    "style": "Power",
    "inherited": false
  },
  {
    "handle": "drop-shot-explorer-pro-60-lucas-campagnolo",
    "title": "Drop Shot Explorer Pro 6.0 - Lucas Campagnolo",
    "vendor": "Drop Shot",
    "url": "/products/drop-shot-explorer-pro-60-lucas-campagnolo",
    "image": "https://cdn.shopify.com/s/files/1/0734/4609/7068/files/bqii9ow59oyt2v1o0apjmxhxf6s6.webp?v=1777598448",
    "price": 11160,
    "compare_at_price": 13899,
    "available": true,
    "level": "Advanced",
    "suitable_levels": [
      "Advanced"
    ],
    "shape": "Round",
    "style": "Control",
    "inherited": false
  },
  {
    "handle": "drop-shot-x-drive-10",
    "title": "Drop Shot X-Drive 1.0",
    "vendor": "Drop Shot",
    "url": "/products/drop-shot-x-drive-10",
    "image": "https://cdn.shopify.com/s/files/1/0734/4609/7068/files/k0kzn7u0hf2yxff9odwwg7otegz2.webp?v=1777598437",
    "price": 13999,
    "compare_at_price": 17550,
    "available": true,
    "level": "Advanced",
    "suitable_levels": [
      "Advanced"
    ],
    "shape": "Diamond",
    "style": "Power",
    "inherited": false
  },
  {
    "handle": "wilson-carbon-force-2026",
    "title": "Wilson Carbon Force 2026",
    "vendor": "Wilson",
    "url": "/products/wilson-carbon-force-2026",
    "image": "https://cdn.shopify.com/s/files/1/0734/4609/7068/files/5w1apst4rwv3028irflohn0d0ikx.jpg?v=1774145784",
    "price": 6499,
    "compare_at_price": 8750,
    "available": true,
    "level": "Beginner",
    "suitable_levels": [
      "Beginner",
      "Intermediate",
      "Women"
    ],
    "shape": "Teardrop",
    "style": "Power",
    "inherited": false
  },
  {
    "handle": "wilson-defy-pro-v1-2025-javi-garrido-1",
    "title": "Wilson Defy Pro V1 2025 - Javi Garrido",
    "vendor": "Wilson",
    "url": "/products/wilson-defy-pro-v1-2025-javi-garrido-1",
    "image": "https://cdn.shopify.com/s/files/1/0734/4609/7068/files/j0rn5lvkcyqeaj08obl35moj2rlc.webp?v=1779634145",
    "price": 14299,
    "compare_at_price": 0,
    "available": true,
    "level": "Advanced",
    "suitable_levels": [
      "Advanced"
    ],
    "shape": "Diamond",
    "style": "Power",
    "inherited": false
  },
  {
    "handle": "drop-shot-axion-control-jon-sanz",
    "title": "Drop Shot Axion Control - Jon Sanz",
    "vendor": "Drop Shot",
    "url": "/products/drop-shot-axion-control-jon-sanz",
    "image": "https://cdn.shopify.com/s/files/1/0734/4609/7068/files/bpskk2nqbbxtltxilze5w8x24fq1.webp?v=1777598416",
    "price": 16350,
    "compare_at_price": 0,
    "available": true,
    "level": "Advanced",
    "suitable_levels": [
      "Advanced"
    ],
    "shape": "Round",
    "style": "Control",
    "inherited": false
  },
  {
    "handle": "drop-shot-conqueror-control-juan-martin-diaz",
    "title": "Drop Shot Conqueror Control - Juan Martin Diaz",
    "vendor": "Drop Shot",
    "url": "/products/drop-shot-conqueror-control-juan-martin-diaz",
    "image": "https://cdn.shopify.com/s/files/1/0734/4609/7068/files/rqhcqfy09hxun4ax5f962d651b51.webp?v=1777598405",
    "price": 10899,
    "compare_at_price": 0,
    "available": true,
    "level": "Advanced",
    "suitable_levels": [
      "Advanced"
    ],
    "shape": "Teardrop",
    "style": "Control",
    "inherited": false
  },
  {
    "handle": "drop-shot-furia-attack",
    "title": "Drop Shot Furia Attack",
    "vendor": "Drop Shot",
    "url": "/products/drop-shot-furia-attack",
    "image": "https://cdn.shopify.com/s/files/1/0734/4609/7068/files/zpacwnh2rcr7jy2r7jeew82vzum4.webp?v=1777598393",
    "price": 11160,
    "compare_at_price": 13950,
    "available": true,
    "level": "Advanced",
    "suitable_levels": [
      "Advanced"
    ],
    "shape": "Teardrop",
    "style": "Power",
    "inherited": false
  },
  {
    "handle": "drop-shot-furia-control",
    "title": "Drop Shot Furia Control",
    "vendor": "Drop Shot",
    "url": "/products/drop-shot-furia-control",
    "image": "https://cdn.shopify.com/s/files/1/0734/4609/7068/files/r36np47xvi4x0t26tkjajbi80ge2.webp?v=1777598381",
    "price": 11160,
    "compare_at_price": 13950,
    "available": true,
    "level": "Intermediate",
    "suitable_levels": [
      "Intermediate"
    ],
    "shape": "Round",
    "style": "Control",
    "inherited": false
  },
  {
    "handle": "drop-shot-harbour-10",
    "title": "Drop Shot Harbour 1.0",
    "vendor": "Drop Shot",
    "url": "/products/drop-shot-harbour-10",
    "image": "https://cdn.shopify.com/s/files/1/0734/4609/7068/files/z310vsnivz12w7p3p129dzu8hrde.webp?v=1777598370",
    "price": 9199,
    "compare_at_price": 11499,
    "available": true,
    "level": "Advanced",
    "suitable_levels": [
      "Advanced"
    ],
    "shape": "Teardrop",
    "style": "Power",
    "inherited": false
  },
  {
    "handle": "drop-shot-quantum-10",
    "title": "Drop Shot Quantum 1.0",
    "vendor": "Drop Shot",
    "url": "/products/drop-shot-quantum-10",
    "image": "https://cdn.shopify.com/s/files/1/0734/4609/7068/files/lwr2ciittb6crew3xaeaed4rf7r3.webp?v=1777598358",
    "price": 13999,
    "compare_at_price": 17550,
    "available": true,
    "level": "Advanced",
    "suitable_levels": [
      "Advanced"
    ],
    "shape": "Diamond",
    "style": "Balanced",
    "inherited": false
  },
  {
    "handle": "drop-shot-renegade-attack",
    "title": "Drop Shot Renegade Attack",
    "vendor": "Drop Shot",
    "url": "/products/drop-shot-renegade-attack",
    "image": "https://cdn.shopify.com/s/files/1/0734/4609/7068/files/e1ka8eatoj6wgt4nlifriwloaeeo.webp?v=1777598347",
    "price": 9199,
    "compare_at_price": 11499,
    "available": true,
    "level": "Advanced",
    "suitable_levels": [
      "Advanced"
    ],
    "shape": "Teardrop",
    "style": "Power",
    "inherited": false
  },
  {
    "handle": "drop-shot-renegade-control",
    "title": "Drop Shot Renegade Control",
    "vendor": "Drop Shot",
    "url": "/products/drop-shot-renegade-control",
    "image": "https://cdn.shopify.com/s/files/1/0734/4609/7068/files/8hnvs2b68ni31tgz10b3p5bkeo20.webp?v=1777598335",
    "price": 9199,
    "compare_at_price": 11499,
    "available": true,
    "level": "Intermediate",
    "suitable_levels": [
      "Intermediate",
      "Women"
    ],
    "shape": "Round",
    "style": "Control",
    "inherited": false
  },
  {
    "handle": "drop-shot-tacoma-10",
    "title": "Drop Shot Tacoma 1.0",
    "vendor": "Drop Shot",
    "url": "/products/drop-shot-tacoma-10",
    "image": "https://cdn.shopify.com/s/files/1/0734/4609/7068/files/tr4muswoovzrc9yrfsvpul8jkbp2.webp?v=1777598324",
    "price": 12599,
    "compare_at_price": 15750,
    "available": true,
    "level": "Advanced",
    "suitable_levels": [
      "Advanced"
    ],
    "shape": "Teardrop",
    "style": "Control",
    "inherited": false
  },
  {
    "handle": "babolat-technical-viper-2025",
    "title": "Babolat Technical Viper 2025",
    "vendor": "Babolat",
    "url": "/products/babolat-technical-viper-2025",
    "image": "https://cdn.shopify.com/s/files/1/0734/4609/7068/files/bz6uys42ylgpch4xvffub37hkxuq_35df1ade-b01e-46b8-8ab7-a50cadec9cef.webp?v=1777836700",
    "price": 12599,
    "compare_at_price": 14899,
    "available": true,
    "level": "Advanced",
    "suitable_levels": [
      "Advanced"
    ],
    "shape": "Diamond",
    "style": "Power",
    "inherited": false
  },
  {
    "handle": "brisk-challenger-w-350",
    "title": "Brisk CHALLENGER-W 350",
    "vendor": "Brisk",
    "url": "/products/brisk-challenger-w-350",
    "image": "https://cdn.shopify.com/s/files/1/0734/4609/7068/files/l9bu2gsy0749m0vl53i5frn1ugbv.webp?v=1777597989",
    "price": 6499,
    "compare_at_price": 0,
    "available": false,
    "level": "Beginner",
    "suitable_levels": [
      "Beginner",
      "Intermediate"
    ],
    "shape": "Diamond",
    "style": "Balanced",
    "inherited": false
  },
  {
    "handle": "brisk-challenger-360",
    "title": "Brisk CHALLENGER 360",
    "vendor": "Brisk",
    "url": "/products/brisk-challenger-360",
    "image": "https://cdn.shopify.com/s/files/1/0734/4609/7068/files/hy7vbivpjudsg9l6q6lude3ripxs.webp?v=1777597979",
    "price": 6499,
    "compare_at_price": 0,
    "available": false,
    "level": "Beginner",
    "suitable_levels": [
      "Beginner",
      "Intermediate"
    ],
    "shape": "Diamond",
    "style": "Balanced",
    "inherited": false
  },
  {
    "handle": "brisk-challenger-365",
    "title": "Brisk CHALLENGER 365",
    "vendor": "Brisk",
    "url": "/products/brisk-challenger-365",
    "image": "https://cdn.shopify.com/s/files/1/0734/4609/7068/files/ssscgx36535fixmv1bl0zcvm76lu.webp?v=1777597967",
    "price": 6499,
    "compare_at_price": 0,
    "available": false,
    "level": "Beginner",
    "suitable_levels": [
      "Beginner",
      "Intermediate"
    ],
    "shape": "Diamond",
    "style": "Balanced",
    "inherited": false
  },
  {
    "handle": "brisk-elite-w-355",
    "title": "Brisk ELITE-W 355",
    "vendor": "Brisk",
    "url": "/products/brisk-elite-w-355",
    "image": "https://cdn.shopify.com/s/files/1/0734/4609/7068/files/sdr5jt0tl0yad3re0j7orskyvrui.webp?v=1777597955",
    "price": 8899,
    "compare_at_price": 0,
    "available": true,
    "level": "Beginner",
    "suitable_levels": [
      "Beginner",
      "Intermediate"
    ],
    "shape": "Diamond",
    "style": "Balanced",
    "inherited": false
  },
  {
    "handle": "brisk-elite-365",
    "title": "Brisk ELITE 365",
    "vendor": "Brisk",
    "url": "/products/brisk-elite-365",
    "image": "https://cdn.shopify.com/s/files/1/0734/4609/7068/files/j60p9qtkt3k9t3d4fnzvajypabm5.webp?v=1777597943",
    "price": 8899,
    "compare_at_price": 0,
    "available": true,
    "level": "Beginner",
    "suitable_levels": [
      "Beginner",
      "Intermediate"
    ],
    "shape": "Diamond",
    "style": "Balanced",
    "inherited": false
  },
  {
    "handle": "brisk-zenith-w-355",
    "title": "Brisk Zenith-W 355",
    "vendor": "Brisk",
    "url": "/products/brisk-zenith-w-355",
    "image": "https://cdn.shopify.com/s/files/1/0734/4609/7068/files/dx1vvsr11n2ix8l9r33fv8udl2d2.webp?v=1777597920",
    "price": 10899,
    "compare_at_price": 0,
    "available": true,
    "level": "Beginner",
    "suitable_levels": [
      "Beginner",
      "Intermediate",
      "Women"
    ],
    "shape": "Diamond",
    "style": "Power",
    "inherited": false
  },
  {
    "handle": "brisk-zenith-365",
    "title": "Brisk Zenith 365",
    "vendor": "Brisk",
    "url": "/products/brisk-zenith-365",
    "image": "https://cdn.shopify.com/s/files/1/0734/4609/7068/files/dnw5n739q3zlj7n0kljg0nvlbr21.webp?v=1777597909",
    "price": 8888,
    "compare_at_price": 10900,
    "available": true,
    "level": "Intermediate",
    "suitable_levels": [
      "Intermediate",
      "Advanced"
    ],
    "shape": "Diamond",
    "style": "Power",
    "inherited": false
  },
  {
    "handle": "brisk-zenith-370",
    "title": "Brisk Zenith 370",
    "vendor": "Brisk",
    "url": "/products/brisk-zenith-370",
    "image": "https://cdn.shopify.com/s/files/1/0734/4609/7068/files/bm546qusgr0ld8aum9qy9tq986md.webp?v=1777597900",
    "price": 10899,
    "compare_at_price": 0,
    "available": false,
    "level": "Advanced",
    "suitable_levels": [
      "Advanced"
    ],
    "shape": "Diamond",
    "style": "Power",
    "inherited": false
  },
  {
    "handle": "bullpadel-vertex-05-w-2026",
    "title": "Bullpadel Vertex 05 W 2026 - Women",
    "vendor": "Bullpadel",
    "url": "/products/bullpadel-vertex-05-w-2026",
    "image": "https://cdn.shopify.com/s/files/1/0734/4609/7068/files/9uooys06c2i6i51f56csnwm255u6.webp?v=1777597805",
    "price": 15499,
    "compare_at_price": 16000,
    "available": true,
    "level": "Advanced",
    "suitable_levels": [
      "Advanced",
      "Women"
    ],
    "shape": "Diamond",
    "style": "Power",
    "inherited": false
  },
  {
    "handle": "bullpadel-hack-04-hybrid-2026-control",
    "title": "Bullpadel Hack 04 Hybrid 2026 - Control",
    "vendor": "Bullpadel",
    "url": "/products/bullpadel-hack-04-hybrid-2026-control",
    "image": "https://cdn.shopify.com/s/files/1/0734/4609/7068/files/s1hnswuzy22i5fhepr0tu9akt14w.webp?v=1777597784",
    "price": 17499,
    "compare_at_price": 19500,
    "available": false,
    "level": "Advanced",
    "suitable_levels": [
      "Advanced"
    ],
    "shape": "Teardrop",
    "style": "Balanced",
    "inherited": false
  },
  {
    "handle": "bullpadel-hack-04-comfort-2026",
    "title": "Bullpadel Hack 04 CMF 2026 - Comfort",
    "vendor": "Bullpadel",
    "url": "/products/bullpadel-hack-04-comfort-2026",
    "image": "https://cdn.shopify.com/s/files/1/0734/4609/7068/files/wgmvo5sujzp43u3qcxios2yd0l53.webp?v=1777597775",
    "price": 15499,
    "compare_at_price": 16000,
    "available": true,
    "level": "Intermediate",
    "suitable_levels": [
      "Intermediate"
    ],
    "shape": "Diamond",
    "style": "Balanced",
    "inherited": false
  },
  {
    "handle": "bullpadel-xplo-comfort-2026",
    "title": "Bullpadel Xplo CMF 2026 - Comfort",
    "vendor": "Bullpadel",
    "url": "/products/bullpadel-xplo-comfort-2026",
    "image": "https://cdn.shopify.com/s/files/1/0734/4609/7068/files/cfeg1nfmnl5vibh1iqgngy0gaw68.webp?v=1777597762",
    "price": 15499,
    "compare_at_price": 16000,
    "available": true,
    "level": "Advanced",
    "suitable_levels": [
      "Advanced"
    ],
    "shape": "Diamond",
    "style": "Power",
    "inherited": false
  },
  {
    "handle": "bullpadel-xplo-2026-martin-di-nenno",
    "title": "Bullpadel Xplo 2026 - Martin Di Nenno",
    "vendor": "Bullpadel",
    "url": "/products/bullpadel-xplo-2026-martin-di-nenno",
    "image": "https://cdn.shopify.com/s/files/1/0734/4609/7068/files/yah611khzjht195dka9y3qg2pnbm.webp?v=1777836505",
    "price": 15650,
    "compare_at_price": 19500,
    "available": true,
    "level": "Advanced",
    "suitable_levels": [
      "Advanced"
    ],
    "shape": "Diamond",
    "style": "Power",
    "inherited": false
  },
  {
    "handle": "bullpadel-hack-04-2026-paquito-navarro",
    "title": "Bullpadel Hack 04 2026 - Paquito Navarro",
    "vendor": "Bullpadel",
    "url": "/products/bullpadel-hack-04-2026-paquito-navarro",
    "image": "https://cdn.shopify.com/s/files/1/0734/4609/7068/files/ctm40haxvkrtpnsjvs6h682jy1f5.webp?v=1777597723",
    "price": 15650,
    "compare_at_price": 19500,
    "available": true,
    "level": "Advanced",
    "suitable_levels": [
      "Advanced"
    ],
    "shape": "Diamond",
    "style": "Power",
    "inherited": false
  },
  {
    "handle": "bullpadel-vertex-05-2026-juan-tello",
    "title": "Bullpadel Vertex 05 2026 - Juan Tello",
    "vendor": "Bullpadel",
    "url": "/products/bullpadel-vertex-05-2026-juan-tello",
    "image": "https://cdn.shopify.com/s/files/1/0734/4609/7068/files/yhx44zmzb5rkn53e3wrnzg8hwgic.webp?v=1777597714",
    "price": 15650,
    "compare_at_price": 19500,
    "available": true,
    "level": "Advanced",
    "suitable_levels": [
      "Advanced"
    ],
    "shape": "Diamond",
    "style": "Power",
    "inherited": false
  },
  {
    "handle": "wilson-bela-lt-v25-2025-fernando-belastegun",
    "title": "Wilson Bela LT V2.5 2025 - Fernando Belasteguín",
    "vendor": "Wilson",
    "url": "/products/wilson-bela-lt-v25-2025-fernando-belastegun",
    "image": "https://cdn.shopify.com/s/files/1/0734/4609/7068/files/cwc2kn76vz135i8euch4dtqyifbe.webp?v=1777597705",
    "price": 12999,
    "compare_at_price": 0,
    "available": true,
    "level": "Intermediate",
    "suitable_levels": [
      "Intermediate"
    ],
    "shape": "Diamond",
    "style": "Balanced",
    "inherited": false
  },
  {
    "handle": "nox-vk10-ventus-control-12k-2026-aranzazu-osoro",
    "title": "Nox VK10 Ventus Control 12K 2026 - Aranzazu Osoro",
    "vendor": "Nox",
    "url": "/products/nox-vk10-ventus-control-12k-2026-aranzazu-osoro",
    "image": "https://cdn.shopify.com/s/files/1/0734/4609/7068/files/vslhxh4a28sa4l2qsq5v1z5147f2.webp?v=1777597492",
    "price": 9999,
    "compare_at_price": 13499,
    "available": true,
    "level": "Advanced",
    "suitable_levels": [
      "Advanced",
      "Women"
    ],
    "shape": "Round",
    "style": "Control",
    "inherited": false
  },
  {
    "handle": "nox-ea10-ventus-attack-12k-xtrem-2026-edu-alonso",
    "title": "Nox EA10 Ventus Attack 12K XTREM 2026 - Edu Alonso",
    "vendor": "Nox",
    "url": "/products/nox-ea10-ventus-attack-12k-xtrem-2026-edu-alonso",
    "image": "https://cdn.shopify.com/s/files/1/0734/4609/7068/files/0tcbn3838ez05d8q9yh1cc5g06xi.webp?v=1777597477",
    "price": 10499,
    "compare_at_price": 14999,
    "available": true,
    "level": "Advanced",
    "suitable_levels": [
      "Intermediate",
      "Advanced"
    ],
    "shape": "Diamond",
    "style": "Power",
    "inherited": false
  },
  {
    "handle": "nox-at10-luxury-genius-18k-alum-2026-agustn-tapia",
    "title": "Nox AT10 Luxury Genius 18K Alum 2026 - Agustín Tapia",
    "vendor": "Nox",
    "url": "/products/nox-at10-luxury-genius-18k-alum-2026-agustn-tapia",
    "image": "https://cdn.shopify.com/s/files/1/0734/4609/7068/files/9ix1e22kzkbf0isbk1l9d1zlpscb.webp?v=1774145922",
    "price": 14499,
    "compare_at_price": 17900,
    "available": false,
    "level": "Advanced",
    "suitable_levels": [
      "Intermediate",
      "Advanced"
    ],
    "shape": "Teardrop",
    "style": "Balanced",
    "inherited": false
  },
  {
    "handle": "wilson-bela-v3-2026-javi-leal",
    "title": "Wilson Bela V3 2026 - Javi Leal",
    "vendor": "Wilson",
    "url": "/products/wilson-bela-v3-2026-javi-leal",
    "image": "https://cdn.shopify.com/s/files/1/0734/4609/7068/files/wmosjg98smp9gkwt3942fnwur2i8.webp?v=1777597380",
    "price": 12999,
    "compare_at_price": 0,
    "available": false,
    "level": "Intermediate",
    "suitable_levels": [
      "Intermediate",
      "Advanced"
    ],
    "shape": "Hybrid",
    "style": "Balanced",
    "inherited": false
  },
  {
    "handle": "wilson-bela-pro-v3-2026-javi-leal",
    "title": "Wilson Bela Pro V3 2026 - Javi Leal",
    "vendor": "Wilson",
    "url": "/products/wilson-bela-pro-v3-2026-javi-leal",
    "image": "https://cdn.shopify.com/s/files/1/0734/4609/7068/files/k6xtcz45z4k97jutyh3uuwy2lote.webp?v=1777597371",
    "price": 14299,
    "compare_at_price": 0,
    "available": false,
    "level": "Advanced",
    "suitable_levels": [
      "Advanced"
    ],
    "shape": "Diamond",
    "style": "Power",
    "inherited": false
  },
  {
    "handle": "babolat-technical-viper-3-0-2026-juan-lebron",
    "title": "Babolat Technical Viper 3.0 2026 - Juan Lebron",
    "vendor": "Babolat",
    "url": "/products/babolat-technical-viper-3-0-2026-juan-lebron",
    "image": "https://cdn.shopify.com/s/files/1/0734/4609/7068/files/b0iu9yw2figl3g9ew3ma5ruv8hwo.jpg?v=1788048019",
    "price": 16666,
    "compare_at_price": 19000,
    "available": true,
    "level": "Advanced",
    "suitable_levels": [
      "Advanced"
    ],
    "shape": "Diamond",
    "style": "Power",
    "inherited": false
  },
  {
    "handle": "babolat-technical-veron-3-0-2026-juan-lebron",
    "title": "Babolat Technical Veron 3.0 2026 - Juan Lebron",
    "vendor": "Babolat",
    "url": "/products/babolat-technical-veron-3-0-2026-juan-lebron",
    "image": "https://cdn.shopify.com/s/files/1/0734/4609/7068/files/xuhyxstz2m4vo5gb2ig5eric9f58.jpg?v=1788048202",
    "price": 11999,
    "compare_at_price": 0,
    "available": true,
    "level": "Advanced",
    "suitable_levels": [
      "Intermediate",
      "Advanced"
    ],
    "shape": "Diamond",
    "style": "Power",
    "inherited": false
  },
  {
    "handle": "babolat-counter-viper-2-6-2026",
    "title": "Babolat Counter Viper 2.6 2026",
    "vendor": "Babolat",
    "url": "/products/babolat-counter-viper-2-6-2026",
    "image": "https://cdn.shopify.com/s/files/1/0734/4609/7068/files/69pax0aueig3o6duvnb5ax48hzlf.jpg?v=1788048027",
    "price": 15499,
    "compare_at_price": 0,
    "available": true,
    "level": "Advanced",
    "suitable_levels": [
      "Intermediate",
      "Advanced"
    ],
    "shape": "Hybrid",
    "style": "Control",
    "inherited": false
  },
  {
    "handle": "wilson-optix-v1-black-2026",
    "title": "Wilson Optix V1 Black 2026",
    "vendor": "Wilson",
    "url": "/products/wilson-optix-v1-black-2026",
    "image": "https://cdn.shopify.com/s/files/1/0734/4609/7068/files/groa84vdjv20mzqr6hoxorosb77l.webp?v=1777661778",
    "price": 5850,
    "compare_at_price": 0,
    "available": true,
    "level": "Beginner",
    "suitable_levels": [
      "Beginner",
      "Women",
      "Junior"
    ],
    "shape": "Round",
    "style": "Control",
    "inherited": false
  },
  {
    "handle": "wilson-optix-xp-padel-kit-box-2026-bundle",
    "title": "Wilson Optix XP Padel Kit Box 2026 - Bundle",
    "vendor": "Wilson",
    "url": "/products/wilson-optix-xp-padel-kit-box-2026-bundle",
    "image": "https://cdn.shopify.com/s/files/1/0734/4609/7068/files/yfu7ajtw2nrxjdad8j2gz8y2sqo9.webp?v=1777661788",
    "price": 7150,
    "compare_at_price": 0,
    "available": true,
    "level": "Beginner",
    "suitable_levels": [
      "Beginner",
      "Women",
      "Junior"
    ],
    "shape": "Round",
    "style": "Control",
    "inherited": true
  },
  {
    "handle": "babolat-technical-viper-3-0-2026",
    "title": "Babolat Technical Viper 3.0 2026",
    "vendor": "Babolat",
    "url": "/products/babolat-technical-viper-3-0-2026",
    "image": "https://cdn.shopify.com/s/files/1/0734/4609/7068/files/irhvkwijcszr4vg1qsror3g2ctv4.jpg?v=1788047815",
    "price": 16999,
    "compare_at_price": 18000,
    "available": true,
    "level": "Advanced",
    "suitable_levels": [
      "Advanced"
    ],
    "shape": "Diamond",
    "style": "Power",
    "inherited": false
  },
  {
    "handle": "babolat-technical-viper-soft-3-0-2026",
    "title": "Babolat Technical Viper Soft 3.0 2026",
    "vendor": "Babolat",
    "url": "/products/babolat-technical-viper-soft-3-0-2026",
    "image": "https://cdn.shopify.com/s/files/1/0734/4609/7068/files/kf0qn41bq3mrkx4xvngqemc869i8.jpg?v=1788048209",
    "price": 12999,
    "compare_at_price": 14500,
    "available": true,
    "level": "Advanced",
    "suitable_levels": [
      "Advanced"
    ],
    "shape": "Diamond",
    "style": "Power",
    "inherited": false
  },
  {
    "handle": "tecnifibre-curva-team-2026",
    "title": "Tecnifibre Curva Team 2026",
    "vendor": "Tecnifibre",
    "url": "/products/tecnifibre-curva-team-2026",
    "image": "https://cdn.shopify.com/s/files/1/0734/4609/7068/files/wmsntzsmsu0n1nj38hgwn2w922om.webp?v=1778101931",
    "price": 4950,
    "compare_at_price": 0,
    "available": true,
    "level": "Beginner",
    "suitable_levels": [
      "Beginner",
      "Intermediate"
    ],
    "shape": "Teardrop",
    "style": "Balanced",
    "inherited": false
  },
  {
    "handle": "tecnifibre-bomba-lite",
    "title": "Tecnifibre Bomba Lite",
    "vendor": "Tecnifibre",
    "url": "/products/tecnifibre-bomba-lite",
    "image": "https://cdn.shopify.com/s/files/1/0734/4609/7068/files/16BOMBALI6_01.jpg?v=1781835989",
    "price": 8450,
    "compare_at_price": 0,
    "available": true,
    "level": "Beginner",
    "suitable_levels": [
      "Beginner",
      "Women",
      "Junior"
    ],
    "shape": "Diamond",
    "style": "Balanced",
    "inherited": false
  },
  {
    "handle": "tecnifibre-bomba-max",
    "title": "Tecnifibre Bomba Max",
    "vendor": "Tecnifibre",
    "url": "/products/tecnifibre-bomba-max",
    "image": "https://cdn.shopify.com/s/files/1/0734/4609/7068/files/16BOMBAMA6_01.jpg?v=1781836033",
    "price": 13000,
    "compare_at_price": 0,
    "available": true,
    "level": "Advanced",
    "suitable_levels": [
      "Intermediate",
      "Advanced"
    ],
    "shape": "Diamond",
    "style": "Power",
    "inherited": false
  },
  {
    "handle": "tecnifibre-bomba-speed",
    "title": "Tecnifibre Bomba Speed",
    "vendor": "Tecnifibre",
    "url": "/products/tecnifibre-bomba-speed",
    "image": "https://cdn.shopify.com/s/files/1/0734/4609/7068/files/16BOMBASP6_01.jpg?v=1781836050",
    "price": 11700,
    "compare_at_price": 0,
    "available": true,
    "level": "Advanced",
    "suitable_levels": [
      "Intermediate",
      "Advanced",
      "Women"
    ],
    "shape": "Diamond",
    "style": "Power",
    "inherited": false
  },
  {
    "handle": "tecnifibre-bomba-soft",
    "title": "Tecnifibre Bomba Soft",
    "vendor": "Tecnifibre",
    "url": "/products/tecnifibre-bomba-soft",
    "image": "https://cdn.shopify.com/s/files/1/0734/4609/7068/files/16BOMBASO6_01.jpg?v=1781836062",
    "price": 9750,
    "compare_at_price": 0,
    "available": true,
    "level": "Advanced",
    "suitable_levels": [
      "Intermediate",
      "Advanced",
      "Women"
    ],
    "shape": "Diamond",
    "style": "Balanced",
    "inherited": false
  },
  {
    "handle": "wilson-endure-pro-v1-2026",
    "title": "Wilson Endure Pro V1 2026",
    "vendor": "Wilson",
    "url": "/products/wilson-endure-pro-v1-2026",
    "image": "https://cdn.shopify.com/s/files/1/0734/4609/7068/files/endure-pro-v1-01.jpg?v=1788048350",
    "price": 14300,
    "compare_at_price": 0,
    "available": true,
    "level": "Advanced",
    "suitable_levels": [
      "Intermediate",
      "Advanced"
    ],
    "shape": "Round",
    "style": "Control",
    "inherited": false
  },
  {
    "handle": "wilson-endure-v1-2026",
    "title": "Wilson Endure V1 2026",
    "vendor": "Wilson",
    "url": "/products/wilson-endure-v1-2026",
    "image": "https://cdn.shopify.com/s/files/1/0734/4609/7068/files/endure-v1-01.webp?v=1783770165",
    "price": 14300,
    "compare_at_price": 0,
    "available": true,
    "level": "Intermediate",
    "suitable_levels": [
      "Intermediate"
    ],
    "shape": "Round",
    "style": "Control",
    "inherited": false
  },
  {
    "handle": "wilson-endure-ls-v1-2026",
    "title": "Wilson Endure LS V1 2026",
    "vendor": "Wilson",
    "url": "/products/wilson-endure-ls-v1-2026",
    "image": "https://cdn.shopify.com/s/files/1/0734/4609/7068/files/endure-ls-v1-01.webp?v=1783770179",
    "price": 11050,
    "compare_at_price": 0,
    "available": true,
    "level": "Intermediate",
    "suitable_levels": [
      "Intermediate"
    ],
    "shape": "Round",
    "style": "Control",
    "inherited": false
  },
  {
    "handle": "wilson-optix-v2-power-blue-2026",
    "title": "Wilson Optix V2 Power Blue 2026",
    "vendor": "Wilson",
    "url": "/products/wilson-optix-v2-power-blue-2026",
    "image": "https://cdn.shopify.com/s/files/1/0734/4609/7068/files/optix-v2-power-blue-01.webp?v=1783770194",
    "price": 6500,
    "compare_at_price": 0,
    "available": false,
    "level": "Beginner",
    "suitable_levels": [
      "Beginner",
      "Intermediate"
    ],
    "shape": "Teardrop",
    "style": "Power",
    "inherited": false
  },
  {
    "handle": "wilson-optix-v2-power-red-2026",
    "title": "Wilson Optix V2 Power Red 2026",
    "vendor": "Wilson",
    "url": "/products/wilson-optix-v2-power-red-2026",
    "image": "https://cdn.shopify.com/s/files/1/0734/4609/7068/files/optix-v2-power-red-01.webp?v=1783770208",
    "price": 6500,
    "compare_at_price": 0,
    "available": true,
    "level": "Beginner",
    "suitable_levels": [
      "Beginner",
      "Intermediate"
    ],
    "shape": "Teardrop",
    "style": "Power",
    "inherited": false
  },
  {
    "handle": "wilson-optix-v2-lite-lilac-2026",
    "title": "Wilson Optix V2 Lite Lilac 2026",
    "vendor": "Wilson",
    "url": "/products/wilson-optix-v2-lite-lilac-2026",
    "image": "https://cdn.shopify.com/s/files/1/0734/4609/7068/files/optix-v2-lite-lilac-01.webp?v=1783770221",
    "price": 6500,
    "compare_at_price": 0,
    "available": true,
    "level": "Beginner",
    "suitable_levels": [
      "Beginner",
      "Women",
      "Junior"
    ],
    "shape": "Round",
    "style": "Control",
    "inherited": false
  },
  {
    "handle": "wilson-optix-v2-lite-white-2026",
    "title": "Wilson Optix V2 Lite White 2026",
    "vendor": "Wilson",
    "url": "/products/wilson-optix-v2-lite-white-2026",
    "image": "https://cdn.shopify.com/s/files/1/0734/4609/7068/files/optix-v2-lite-white-01.webp?v=1783770235",
    "price": 6500,
    "compare_at_price": 0,
    "available": true,
    "level": "Beginner",
    "suitable_levels": [
      "Beginner",
      "Women",
      "Junior"
    ],
    "shape": "Round",
    "style": "Control",
    "inherited": false
  },
  {
    "handle": "wilson-endure-bundle-green-friday-2026",
    "title": "Wilson Endure Bundle - Green Friday 2026",
    "vendor": "Wilson",
    "url": "/products/wilson-endure-bundle-green-friday-2026",
    "image": "https://cdn.shopify.com/s/files/1/0734/4609/7068/files/image_47a09986-c09a-496f-88b3-3bc8cac022ce.webp?v=1790619979",
    "price": 13999,
    "compare_at_price": 15500,
    "available": true,
    "level": "Intermediate",
    "suitable_levels": [
      "Intermediate",
      "Advanced"
    ],
    "shape": "Round",
    "style": "Control",
    "inherited": true
  },
  {
    "handle": "babolat-air-vertuo-2-6-2026",
    "title": "Babolat Air Vertuo 2.6 2026",
    "vendor": "Babolat",
    "url": "/products/babolat-air-vertuo-2-6-2026",
    "image": "https://cdn.shopify.com/s/files/1/0734/4609/7068/files/vertuo-1.jpg?v=1788048139",
    "price": 9400,
    "compare_at_price": 0,
    "available": true,
    "level": "Beginner",
    "suitable_levels": [
      "Beginner",
      "Intermediate"
    ],
    "shape": "Teardrop",
    "style": "Balanced",
    "inherited": false
  },
  {
    "handle": "babolat-air-viper-2-6-2026",
    "title": "Babolat Air Viper 2.6 2026",
    "vendor": "Babolat",
    "url": "/products/babolat-air-viper-2-6-2026",
    "image": "https://cdn.shopify.com/s/files/1/0734/4609/7068/files/viper-1.jpg?v=1788047988",
    "price": 16599,
    "compare_at_price": 0,
    "available": true,
    "level": "Intermediate",
    "suitable_levels": [
      "Intermediate",
      "Advanced"
    ],
    "shape": "Teardrop",
    "style": "Power",
    "inherited": false
  },
  {
    "handle": "babolat-alioth-mini-jr-2025",
    "title": "Babolat Alioth Mini JR 2025",
    "vendor": "Babolat",
    "url": "/products/babolat-alioth-mini-jr-2025",
    "image": "https://cdn.shopify.com/s/files/1/0734/4609/7068/files/alioth-1.png?v=1787092848",
    "price": 5200,
    "compare_at_price": 0,
    "available": true,
    "level": "Beginner",
    "suitable_levels": [
      "Beginner",
      "Junior"
    ],
    "shape": "Round",
    "style": "Balanced",
    "inherited": false
  },
  {
    "handle": "babolat-counter-vertuo-2-6-2026",
    "title": "Babolat Counter Vertuo 2.6 2026",
    "vendor": "Babolat",
    "url": "/products/babolat-counter-vertuo-2-6-2026",
    "image": "https://cdn.shopify.com/s/files/1/0734/4609/7068/files/cvertuo-1.jpg?v=1788048156",
    "price": 9900,
    "compare_at_price": 0,
    "available": true,
    "level": "Beginner",
    "suitable_levels": [
      "Beginner",
      "Intermediate"
    ],
    "shape": "Round",
    "style": "Control",
    "inherited": false
  },
  {
    "handle": "babolat-counter-origin-2025",
    "title": "Babolat Counter Origin 2025",
    "vendor": "Babolat",
    "url": "/products/babolat-counter-origin-2025",
    "image": "https://cdn.shopify.com/s/files/1/0734/4609/7068/files/corigin-1.jpg?v=1788048245",
    "price": 6400,
    "compare_at_price": 0,
    "available": true,
    "level": "Beginner",
    "suitable_levels": [
      "Beginner",
      "Intermediate"
    ],
    "shape": "Round",
    "style": "Control",
    "inherited": false
  },
  {
    "handle": "babolat-air-viper-2-6-bundle-2026",
    "title": "Babolat Air Viper 2.6 Bundle - Green Friday 2026",
    "vendor": "Babolat",
    "url": "/products/babolat-air-viper-2-6-bundle-2026",
    "image": "https://cdn.shopify.com/s/files/1/0734/4609/7068/files/babolat-air-viper-2-6-bundle-2026_ed54b9ee-ba46-4301-9568-11b82fa45063.jpg?v=1790622346",
    "price": 15999,
    "compare_at_price": 18000,
    "available": true,
    "level": "Intermediate",
    "suitable_levels": [
      "Intermediate",
      "Advanced"
    ],
    "shape": "Teardrop",
    "style": "Power",
    "inherited": true
  },
  {
    "handle": "drop-shot-axion-attack-bundle-jon-sanz",
    "title": "Drop Shot Axion Attack Bundle - Jon Sanz",
    "vendor": "Drop Shot",
    "url": "/products/drop-shot-axion-attack-bundle-jon-sanz",
    "image": "https://cdn.shopify.com/s/files/1/0734/4609/7068/files/drop-shot-axion-attack-bundle-jon-sanz.webp?v=1787488475",
    "price": 12999,
    "compare_at_price": 13438,
    "available": true,
    "level": "Advanced",
    "suitable_levels": [
      "Advanced"
    ],
    "shape": "Teardrop",
    "style": "Power",
    "inherited": true
  },
  {
    "handle": "tecnifibre-curva-team-duo-bundle-green-friday-2026",
    "title": "Tecnifibre Curva Team Duo Bundle - Green Friday 2026",
    "vendor": "Tecnifibre",
    "url": "/products/tecnifibre-curva-team-duo-bundle-green-friday-2026",
    "image": "https://cdn.shopify.com/s/files/1/0734/4609/7068/files/GreenFridayBestiesBundle.webp?v=1789789427",
    "price": 9999,
    "compare_at_price": 10988,
    "available": true,
    "level": "Beginner",
    "suitable_levels": [
      "Beginner",
      "Intermediate"
    ],
    "shape": "Teardrop",
    "style": "Balanced",
    "inherited": true
  },
  {
    "handle": "brisk-zenith-bundle-green-friday-2026",
    "title": "Brisk Zenith 365 Bundle - Green Friday 2026",
    "vendor": "Babolat",
    "url": "/products/brisk-zenith-bundle-green-friday-2026",
    "image": "https://cdn.shopify.com/s/files/1/0734/4609/7068/files/BriskGreenFridayBundle_1_0f00d7ab-9d9f-47c1-a778-5e73948018ff.webp?v=1791649051",
    "price": 9999,
    "compare_at_price": 11500,
    "available": true,
    "level": "Intermediate",
    "suitable_levels": [
      "Intermediate",
      "Advanced"
    ],
    "shape": "Diamond",
    "style": "Power",
    "inherited": true
  },
  {
    "handle": "siux-fenix-pro-2026-leo-augsburger",
    "title": "Siux Fenix Pro 2026 - Leo Augsburger",
    "vendor": "Siux",
    "url": "/products/siux-fenix-pro-2026-leo-augsburger",
    "image": "https://cdn.shopify.com/s/files/1/0734/4609/7068/files/fenix-pro-1.jpg?v=1790847904",
    "price": 13499,
    "compare_at_price": 18200,
    "available": true,
    "level": "Advanced",
    "suitable_levels": [
      "Advanced"
    ],
    "shape": "Diamond",
    "style": "Power",
    "inherited": false
  },
  {
    "handle": "siux-electra-pro-2026-franco-stupaczuk",
    "title": "Siux Electra Pro 2026 - Franco Stupaczuk",
    "vendor": "Siux",
    "url": "/products/siux-electra-pro-2026-franco-stupaczuk",
    "image": "https://cdn.shopify.com/s/files/1/0734/4609/7068/files/electra-pro-1.jpg?v=1790847921",
    "price": 12999,
    "compare_at_price": 18200,
    "available": false,
    "level": "Intermediate",
    "suitable_levels": [
      "Intermediate",
      "Advanced"
    ],
    "shape": "Teardrop",
    "style": "Balanced",
    "inherited": false
  }
];
